import { Link, useLocation, useNavigate } from "react-router";
import { LayoutGrid, Star, Settings, LogOut } from "lucide-react";
import { createClient } from "@/lib/supabase/client";

const TABS = [
  { href: "/stocks", label: "Coverage", icon: LayoutGrid },
  { href: "/attention", label: "My List", icon: Star },
  { href: "/settings", label: "Settings", icon: Settings },
] as const;

export function MobileNav() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  async function handleLogOut() {
    const supabase = createClient();
    await supabase.auth.signOut();
    navigate("/login");
  }

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden border-t border-border bg-background"
      role="navigation"
      aria-label="Mobile navigation"
    >
      {TABS.map((tab) => {
        const isActive =
          pathname === tab.href || pathname.startsWith(tab.href + "/");
        const Icon = tab.icon;

        return (
          <Link
            key={tab.href}
            to={tab.href}
            className={`flex min-h-[48px] flex-1 flex-col items-center justify-center gap-0.5 py-2 text-xs no-underline transition-colors ${
              isActive
                ? "text-primary"
                : "text-muted-foreground"
            }`}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon className="size-5" aria-hidden="true" />
            <span>{tab.label}</span>
          </Link>
        );
      })}

      <button
        onClick={handleLogOut}
        className="flex min-h-[48px] flex-1 flex-col items-center justify-center gap-0.5 py-2 text-xs text-muted-foreground transition-colors cursor-pointer hover:text-foreground"
        type="button"
      >
        <LogOut className="size-5" aria-hidden="true" />
        <span>Log Out</span>
      </button>
    </nav>
  );
}
